"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStakingVarsAccountInfo = exports.getStakingAccountInfo = exports.getRegisteredStakeAccountInfo = void 0;
const getStakingProgram_1 = require("./../utils/getStakingProgram");
const pda_getters_1 = require("./pda_getters");
/**
 * Returns the contents of the Registered Stake account as detailed in the RegisteredStakeAccountInfo interface
 *
 * @param connection
 * @param programId - Deployed program ID for Staking Program
 * */
function getRegisteredStakeAccountInfo(connection, registeredStake, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, getStakingProgram_1.getStakingProgram)({ connection, programId });
        const registeredStakeAccountInfo = yield program.account.registeredStake.fetch(registeredStake);
        return registeredStakeAccountInfo;
    });
}
exports.getRegisteredStakeAccountInfo = getRegisteredStakeAccountInfo;
/**
 * Returns the contents of the Staking account as detailed in the StakingAccount interface
 *
 * @param connection
 * @param programId - Deployed program ID for Staking Program
 * */
function getStakingAccountInfo(connection, stakingAccount, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, getStakingProgram_1.getStakingProgram)({ connection, programId });
        const stakingAccountInfo = yield program.account.stakingAccount.fetch(stakingAccount);
        return stakingAccountInfo;
    });
}
exports.getStakingAccountInfo = getStakingAccountInfo;
/**
 * Returns the contents of the staking vars account as detailed in the StakingVarsInfo interface
 *
 * @param connection
 * @param programId - Deployed program ID for the Staking Program
 */
function getStakingVarsAccountInfo(connection, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, getStakingProgram_1.getStakingProgram)({
            connection: connection,
            programId: programId,
        });
        const [stakingVarsAccount] = yield (0, pda_getters_1.getStakingVarsAccount)(programId);
        const stakingVarsInfo = yield program.account.stakingVars.fetch(stakingVarsAccount);
        return stakingVarsInfo;
    });
}
exports.getStakingVarsAccountInfo = getStakingVarsAccountInfo;
//# sourceMappingURL=pda_info_getters.js.map